
































































import { PropType } from 'vue';
import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { DPA_RETARGET_OPTIONS } from '../consts';
import TtamLabelOptional from '@/components/common/label-optional/index.vue';

const name = 'ttam-audience-custom-actions';
export default defineComponent({
  name,
  components: { TtamLabelOptional },
  props: {
    isExclude: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    actions: {
      type: Array as PropType<{ code: number; days: number }[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { actions, isExclude } = toRefs(props);
    const daysOptions = ref([1, 2, 3, 7, 14, 30, 60, 90, 180]);
    const retargetActionOptions = ref(DPA_RETARGET_OPTIONS);
    const actionsValue = computed(() => actions.value);
    const showAdd = computed(() => actionsValue.value.length - 1);
    const emptyAddVisible = computed(() => isExclude.value && actions.value.length === 0);
    const lastItem = computed(
      () =>
        function (index) {
          return index === actions.value.length - 1;
        },
    );
    const onActionsChange = (val, index, type) => {
      emit('change', val, index, type);
    };
    const deleteAction = index => {
      emit('delete', index);
    };
    const addAction = () => {
      emit('add');
    };
    return {
      name,
      daysOptions,
      retargetActionOptions,
      actionsValue,
      showAdd,
      lastItem,
      emptyAddVisible,
      onActionsChange,
      deleteAction,
      addAction,
    };
  },
});
